<script setup lang="ts"></script>

<template>
  <div class="widget">
    <slot />
  </div>
</template>

<style scoped>
  .widget {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    background-color: var(--sf-base-background-primary);
    z-index: 1;
  }
</style>
